import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  isPlaying: 0, // 视频是否在播放状态， 0：没有播放， 1：正在播放
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.CHANGE_VIDEO_PLAYING_STATUS:
      return {
        ...state,
        isPlaying: action.data
      };
    default:
      return state;
  }
}
